import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useLayoutEffect, } from "react";
import { productDocumentTitle, } from "@ilabel/product-config";
export { productDocumentTitle };
/*
 * ProductRuntime owns browser-side application identity. The framework-neutral
 * title rule itself lives in product-config so non-React entries can share the
 * same contract.
 */
const ProductConfigContext = createContext(null);
export function ProductRuntime({ config, children, }) {
    useLayoutEffect(() => {
        const previousCode = document.documentElement.dataset.productCode;
        const previousTitle = document.title;
        const existingIcon = document.head.querySelector('link[rel~="icon"]');
        const productIcon = existingIcon ?? document.createElement("link");
        const previousIconRel = existingIcon?.getAttribute("rel") ?? null;
        const previousIconHref = existingIcon?.getAttribute("href") ?? null;
        document.documentElement.dataset.productCode = config.code;
        document.title = productDocumentTitle(undefined, config.brand.applicationName);
        productIcon.setAttribute("rel", "icon");
        productIcon.setAttribute("href", config.brand.logoPath);
        productIcon.dataset.ilabelProductIcon = config.code;
        if (!existingIcon)
            document.head.append(productIcon);
        return () => {
            if (previousCode === undefined)
                delete document.documentElement.dataset.productCode;
            else
                document.documentElement.dataset.productCode = previousCode;
            document.title = previousTitle;
            if (!existingIcon)
                productIcon.remove();
            else {
                if (previousIconRel === null)
                    productIcon.removeAttribute("rel");
                else
                    productIcon.setAttribute("rel", previousIconRel);
                if (previousIconHref === null)
                    productIcon.removeAttribute("href");
                else
                    productIcon.setAttribute("href", previousIconHref);
                delete productIcon.dataset.ilabelProductIcon;
            }
        };
    }, [config]);
    return (_jsx(ProductConfigContext.Provider, { value: config, children: children }));
}
export function useProductConfig() {
    const config = useContext(ProductConfigContext);
    if (!config)
        throw new Error("useProductConfig must be used inside ProductRuntime");
    return config;
}
export function useProductDocumentTitle(pageName) {
    const config = useProductConfig();
    useEffect(() => {
        document.title = productDocumentTitle(pageName, config.brand.applicationName);
    }, [config, pageName]);
}
export function isProductFeatureEnabled(config, feature) {
    return config.features[feature];
}
export function isProductMenuEnabled(config, menuKey) {
    return config.navigation.menuKeys.some((key) => key === menuKey);
}
export function productApiPath(config, path) {
    if (!path.startsWith("/"))
        throw new TypeError("API resource path must start with /");
    return `${config.api.basePath.replace(/\/$/, "")}${path}`;
}
//# sourceMappingURL=product-runtime.js.map